import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/bookmarkCheck.svg';

export const IconBookmarkCheck = createIconComponent(Icon);
